<template>
  <div class="post-wrap"  v-bar>
    <div class="infinite-list">
      <template v-if="posts.length">
        <el-card class="card-margin" :class="`card card--${post.trust.trust == 1 ? 'positive' : post.trust.trust == -1 ? 'negative' : 'netural'}`" shadow="hover" v-for="(post, index) in posts" :key="index">
          <div class="card-inner">
            <div v-if="copyRemoved" class="is-removed">Пост будет исключен из выдачи</div>
            <post-header :post="post" class="post-header"/>
            <!--<post-body :post="post" :isRepost="false" @setTrust="setTrust"/>-->
            
            <div class="post-body">
              <div class="post-body__additional">

                <trust
                  v-if="!isRepost"
                  :trust="post.trust ? post.trust: 0"
                  @setTrust="setTrust"
                ></trust>
              </div>

              <div class="post-body__text" v-html="trimHref(post)"></div>
            </div>

            <post-header v-if="!!post.repost.id" :isRepost="!!post.repost.id" :post="post.repost" class="post-header"/>
            <!--<post-body v-if="post.repost.id" :post="post.repost" :isRepost="true" @setTrust="setTrust"/>-->

            <div class="post-info-panel">
              <div class="post-info-panel__item" v-if="showMoreButton(post)">
                <span v-if="!moreButton" @click="showMore(post)">{{$t('post.postInfoPanel.more')}}</span>
                <span class="post-info-panel__item" v-if="moreButton" @click="showMore(post)">Скрыть</span>
              </div>
              <span v-if="Number(post.comments)" class="post-info-panel__item" @click="toggleComment(post)">{{$t('post.postInfoPanel.comments')}} - {{post.comments}}</span>
            </div>

            <gallery v-if="post.images.length" :images="post.images"/>
            <template v-if="post.repost.id">
              <gallery v-if="post.repost.images.length" :images="post.repost.images"/>
            </template>

            <audio-gallery v-if="post.audio.length" :audios="post.audio" />
            <template v-if="post.repost.id">
              <audio-gallery v-if="post.repost.audio.length" :audios="post.repost.audio" />
            </template>

            <video-gallery v-if="post.video.length" :videos="post.video" />
            <template v-if="post.repost.id">
              <video-gallery v-if="post.repost.video.length" :videos="post.repost.video" />
            </template>

            <commentaries :post="post" v-if="!post.repost.id"/>
          </div>
        </el-card>
      </template>
      <template v-else>
        <div class="posts__not-result">
          <i class="el-icon-search"></i> {{$t('post.noData')}}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  // components
  import PostHeader from './PostHeader';
  import PostBody from './PostBody';
  import Commentaries from './Commentaries';
  import Gallery from './Gallery';
  import VideoGallery from './VideoGallery';
  import AudioGallery from './AudioGallery';

  export default {
    name: 'PostCopy',
    props: {
      posts: {
        type: Array
      },
      excluded: {
        type: Boolean
      },
      copyRemoved: {
        type: Boolean
      },
      loading: {
        type: Boolean
      }
    },
    data() {
      return {
        trimTextLength: 400,
        moreButton: false,
      };
    },
    computed: {


    },
    methods: {
      trimHref(post) {
        //this.replaceByNetwork();
        return this.trimmedText(post);
      },
      trimmedText(post) {
        if (this.moreButton) {
          return post.text;
        }

        if (this.trimTextLength > post.text.length) {
          return post.text;
        }

        return `${post.text.substring(0, this.trimTextLength)} ...`;
      },
      showMoreButton(post) {
        return post.text.length > this.trimTextLength;
      },
      showMore(post) {
        this.$emit('showMore', post);
        this.moreButton = !this.moreButton
      },
      toggleComment(post) {
        this.$emit('toggleComment', post);
      },
      setTrust({postId, trust}) {
        this.$emit('setTrust', {postId, trust});
      },
    },
    components: {
      PostHeader,
      PostBody,
      Commentaries,
      Gallery,
      VideoGallery,
      AudioGallery
    },
  };
</script>

<style>
  .post-wrap {
    padding-top: 20px;
    min-height: 100px;
    height: 100vh;
  }
  .card-margin {
    margin-bottom: 20px;
    position: relative;
  }
  .post-header {
    margin-bottom: 20px;
  }

  .post-info-panel {
    display: flex;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #1F2F3D;
    margin-left: 45px;
    padding: 15px 0 0 10px;
  }

  .post-info-panel__item {
    cursor: pointer;
  }
  .post-info-panel__item:last-child {
    margin-right: 0;
  }
  .posts__not-result {
    border-top: 1px solid #ccc;
    padding-top: 20px;
  }
  .to-ex {
    margin-left: auto;
  }
  .is-removed{
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0px;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(255,255,255,0.8);
    color: #333;


  }
</style>
